import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/ellipse/ellipse_turquoise.svg")